/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9302a31b (Tue Nov  3 17:38:29 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  ProgramDirectoryReportRow,
  ProgramDirectoryReportRowFromJSON,
  ProgramDirectoryReportRowToJSON,
} from './'

/**
 *
 * @export
 * @interface ProgramDirectoryReportResponse
 */
export interface ProgramDirectoryReportResponse {
  /**
   * The name of the community the program belongs to, used for the report title.
   * @type string
   * @memberof ProgramDirectoryReportResponse
   */
  communityName?: string
  /**
   * One row per active (ENROLLED or COMPLETE) enrollment for the specified program.
   * @type {Array<ProgramDirectoryReportRow>}
   * @memberof ProgramDirectoryReportResponse
   */
  data: Array<ProgramDirectoryReportRow>
}

export function ProgramDirectoryReportResponseFromJSON(
  json: any
): ProgramDirectoryReportResponse {
  return ProgramDirectoryReportResponseFromJSONTyped(json, false)
}

export function ProgramDirectoryReportResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProgramDirectoryReportResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    communityName: !exists(json, 'communityName')
      ? undefined
      : json['communityName'],
    data: (json['data'] as Array<any>).map(ProgramDirectoryReportRowFromJSON),
  }
}

export function ProgramDirectoryReportResponseToJSON(
  value?: ProgramDirectoryReportResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    communityName: value.communityName,
    data: (value.data as Array<any>).map(ProgramDirectoryReportRowToJSON),
  }
}
